module.exports = __webpack_public_path__ + "res/img_info_m.36f3af81b660306d2485477bf0aedac5.png";